(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["obapet-cart-content"] && !Shopify.designMode) return;
  try {
    class ObapetCartContent extends HTMLElement {
    static busy = false;
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      clearInterval(this.timer);
      const signal = this.abort.signal;
      this.root = window.Shopify?.routes?.root || '/';
      this.addEventListener('click', event => this.click(event), { signal });
      this.addEventListener('change', event => this.change(event), { signal });
      this.addEventListener('submit', event => this.submit(event), { signal });
      this.renderGoals();
      this.updateTimer();
      if (this.querySelector('[data-countdown]')) this.timer = setInterval(() => this.updateTimer(), 1000);
    }
    disconnectedCallback() { this.abort?.abort(); clearInterval(this.timer); }
    state() { return JSON.parse(this.querySelector('[data-cart-state]').textContent); }
    money(value) { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:this.dataset.currency }).format(value/100); }
    status(message) { const target = document.querySelector('obapet-cart-content [data-status]'); if (target) target.textContent = message; }
    renderGoals() {
      const goals = this.querySelector('[data-goals]');
      if (!goals) return;
      const steps = [...goals.querySelectorAll('[data-goal-step]')];
      const valid = steps.length && steps.every((step,i) => Number(step.dataset.amount)>0 && (!i || Number(step.dataset.amount)>Number(steps[i-1].dataset.amount)));
      if (!valid) { goals.hidden = true; return; }
      const totalFor = step => Number(step.dataset.total ?? this.dataset.goalTotal);
      const labels = JSON.parse(goals.querySelector('[data-goal-text]').textContent);
      const next = steps.find(step => totalFor(step) < Number(step.dataset.amount));
      const last = Number(steps[steps.length-1].dataset.amount);
      goals.querySelector('[data-goal-fill]').style.width = `${Math.min(100,totalFor(steps[steps.length-1])/last*100)}%`;
      goals.querySelector('[data-goal-message]').textContent = next ? labels.more.replace('__AMOUNT__',this.money(Number(next.dataset.amount)-totalFor(next))).replace('__REWARD__',next.dataset.label) : labels.done;
      steps.forEach(step => { const done=totalFor(step)>=Number(step.dataset.amount); step.toggleAttribute('data-unlocked',done); step.setAttribute('aria-label',done ? labels.unlocked.replace('__REWARD__',step.dataset.label):step.dataset.label); });
    }
    updateTimer() {
      const timer = this.querySelector('[data-countdown]');
      if (!timer) return;
      const remaining = Date.parse(timer.dataset.end)-Date.now();
      timer.hidden = !Number.isFinite(remaining) || remaining <= 0;
      if (timer.hidden) return;
      const seconds=Math.floor(remaining/1000), days=Math.floor(seconds/86400), hours=Math.floor(seconds%86400/3600), minutes=Math.floor(seconds%3600/60);
      timer.querySelector('[data-time]').textContent = `${days ? days+'d ' : ''}${String(hours).padStart(2,'0')}:${String(minutes).padStart(2,'0')}:${String(seconds%60).padStart(2,'0')}`;
    }
    async request(path, payload) {
      const options = payload ? { method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload) } : {headers:{Accept:'application/json'}};
      const response = await fetch(this.root+path,options);
      const result=await response.json();
      if (!response.ok || result.status || result.errors) throw new Error(typeof result.description==='string'?result.description:typeof result.errors==='string'?result.errors:this.dataset.error);
      return result;
    }
    sectionData() { return {sections:[this.dataset.section],sections_url:location.pathname}; }
    async refresh(result) {
      let cart = result?.item_count !== undefined ? result : await this.request('cart.js');
      let sections = result?.sections;
      if (!sections?.[this.dataset.section]) {
        const response = await fetch(`${location.pathname}?sections=${encodeURIComponent(this.dataset.section)}`);
        sections=await response.json();
      }
      const native=document.querySelector('cart-drawer-component');
      const dialog=native?.querySelector('dialog');
      if (dialog) { dialog.classList.toggle('cart-drawer--empty',cart.item_count===0); dialog.setAttribute('aria-labelledby',cart.item_count===0?'cart-drawer-heading-empty':'cart-drawer-heading'); }
      document.dispatchEvent(new CustomEvent('cart:update',{detail:{resource:cart,sourceId:'obapet-cart',data:{source:'obapet-cart',itemCount:cart.item_count,sections}},bubbles:true}));
      return cart;
    }
    async operate(task, focus) {
      if (ObapetCartContent.busy) return;
      ObapetCartContent.busy=true;
      this.setAttribute('aria-busy','true');
      this.status('');
      const disabled=[...this.querySelectorAll('button:not([on\\:click]),input,select,textarea')].filter(el=>!el.disabled);
      disabled.forEach(el=>el.disabled=true);
      try { const result=await task(); await this.refresh(result); }
      catch(error) { try { await this.refresh(); } catch {} this.status(error.message || this.dataset.error); }
      finally {
        ObapetCartContent.busy=false;
        this.removeAttribute('aria-busy');
        disabled.forEach(el=>{if(el.isConnected)el.disabled=false;});
        if (focus) setTimeout(()=>document.querySelector(focus)?.focus({preventScroll:true}),50);
      }
    }
    click(event) {
      const button=event.target.closest('button');
      if (!button || !this.contains(button)) return;
      const row=button.closest('[data-line]');
      if (button.hasAttribute('data-remove')) { event.preventDefault(); this.operate(()=>this.request('cart/change.js',{id:row.dataset.key,quantity:0,...this.sectionData()})); }
      else if (button.hasAttribute('data-quantity-change')) {
        event.preventDefault(); const input=row.querySelector('[data-quantity-input]');
        const quantity=Number(input.value)+Number(button.dataset.quantityChange)*Number(input.step || 1);
        if(quantity < Number(input.min||1) || input.max && quantity>Number(input.max)) return;
        this.operate(()=>this.request('cart/change.js',{id:row.dataset.key,quantity,...this.sectionData()}));
      } else if(button.hasAttribute('data-add-suggestion')) {
        event.preventDefault(); const select=button.closest('[data-suggestion]').querySelector('[data-suggestion-variant]');
        this.operate(()=>this.request('cart/add.js',{items:[{id:Number(select.value),quantity:1}],...this.sectionData()}));
      } else if(button.hasAttribute('data-protection')) {
        event.preventDefault(); this.operate(()=>button.dataset.key ? this.request('cart/change.js',{id:button.dataset.key,quantity:0,...this.sectionData()}) : this.request('cart/add.js',{items:[{id:Number(button.dataset.id),quantity:1,properties:{_obapet_protection:'true'}}],...this.sectionData()}));
      } else if(button.hasAttribute('data-slide')) {
        const track=this.querySelector('[data-suggestions]');
        track.scrollBy({left:Number(button.dataset.slide)*(track.clientWidth+10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    change(event) {
      const field=event.target, row=field.closest('[data-line]');
      if(field.hasAttribute('data-quantity-input')) {
        if(!field.checkValidity()) {field.reportValidity();field.value=row.dataset.quantity;return;}
        this.operate(()=>this.request('cart/change.js',{id:row.dataset.key,quantity:Number(field.value),...this.sectionData()}));
      } else if(field.hasAttribute('data-line-variant')) {
        const id=Number(field.value);
        if(id===Number(row.dataset.variant)) return;
        this.operate(()=>this.swapVariant(row,id));
      } else if(field.hasAttribute('data-suggestion-variant')) field.closest('[data-suggestion]').querySelector('[data-suggestion-price]').textContent=field.selectedOptions[0].dataset.price;
    }
    sameProperties(a,b) { const normalize=x=>JSON.stringify(Object.entries(x||{}).sort(([a],[b])=>a.localeCompare(b))); return normalize(a)===normalize(b); }
    async swapVariant(row,id) {
      const before=await this.request('cart.js');
      const original=before.items.find(item=>item.key===row.dataset.key);
      if(!original) throw new Error(this.dataset.review);
      const existing=before.items.find(item=>item.variant_id===id && !item.selling_plan_allocation && this.sameProperties(item.properties,original.properties));
      let added=false;
      try {
        await this.request('cart/add.js',{items:[{id,quantity:original.quantity,properties:original.properties||{}}]});
        added=true;
        const current=await this.request('cart.js');
        const old=current.items.find(item=>item.key===original.key) || current.items.find(item=>item.variant_id===original.variant_id && this.sameProperties(item.properties,original.properties));
        if(!old) throw new Error(this.dataset.review);
        return await this.request('cart/change.js',{id:old.key,quantity:0,...this.sectionData()});
      } catch(error) {
        if(added) {
          try {
            const current=await this.request('cart.js');
            const line=current.items.find(item=>item.variant_id===id && !item.selling_plan_allocation && this.sameProperties(item.properties,original.properties));
            if(line) await this.request('cart/change.js',{id:line.key,quantity:existing?.quantity||0});
          } catch {throw new Error(this.dataset.review);}
        }
        throw error;
      }
    }
    submit(event) {
      const form=event.target;
      if(form.matches('[data-note-form]')) {event.preventDefault(); const note=form.elements.note.value; this.operate(()=>this.request('cart/update.js',{note,...this.sectionData()}));}
      else if(form.matches('[data-discount-form]')) {
        event.preventDefault(); const code=form.elements.discount.value.trim(); if(!code) return;
        this.operate(async()=>{
          const cart=await this.request('cart.js');
          const existing=(cart.discount_codes||[]).filter(x=>x.applicable).map(x=>x.code);
          const result=await this.request('cart/update.js',{discount:[...new Set([...existing,code])].join(','),...this.sectionData()});
          const applied=result.discount_codes?.find(x=>x.code.toLowerCase()===code.toLowerCase());
          if(!applied?.applicable) throw new Error(Theme.translations?.discount_code_error || this.dataset.error);
          return result;
        });
      } else if(ObapetCartContent.busy) event.preventDefault();
    }
  }
  if(!customElements.get('obapet-cart-content')) customElements.define('obapet-cart-content',ObapetCartContent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["obapet-halloween"] && !Shopify.designMode) return;
  try {
    class ObapetHalloweenBar extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      const raw=this.dataset.date || '';
      const end=/^\d{4}-\d{2}-\d{2}$/.test(raw) ? new Date(`${raw}T00:00:00`).getTime() : NaN;
      const countdown=this.querySelector('[data-countdown-wrap]');
      const tick=()=>{
        if(!countdown) return;
        const remaining=Math.floor((end-Date.now())/1000);
        if(!Number.isFinite(remaining)||remaining<=0){countdown.hidden=true;clearInterval(this.interval);return;}
        const units={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
        for(const [unit,value] of Object.entries(units))countdown.querySelector(`[data-unit="${unit}"]`).textContent=String(value).padStart(2,'0');
        countdown.querySelector('[data-countdown-fallback]').hidden=true;
        countdown.querySelector('[data-countdown-digits]').hidden=false;
      };
      tick();
      if(countdown&&!countdown.hidden)this.interval=setInterval(tick,1000);
      const range=this.querySelector('[data-delivery-range]');
      const min=Number(this.dataset.minDays),max=Number(this.dataset.maxDays);
      if(range&&Number.isInteger(min)&&Number.isInteger(max)&&min>0&&max>=min&&max<=365){
        const start=new Date();start.setHours(12,0,0,0);
        const addDays=(count)=>{const date=new Date(start);let days=0;while(days<count){date.setDate(date.getDate()+1);if(this.dataset.businessDays!=='true'||(date.getDay()!==0&&date.getDay()!==6))days++;}return date;};
        const format=new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'short',day:'numeric'});
        range.textContent=`${format.format(addDays(min))} – ${format.format(addDays(max))}`;
      }
    }
    disconnectedCallback(){clearInterval(this.interval);}
  }
  if(!customElements.get('obapet-halloween-bar'))customElements.define('obapet-halloween-bar',ObapetHalloweenBar);
  } catch(e) { console.error(e); }
})();

})();
